import React, { useEffect, useState } from 'react';
import { isTauri } from '@tauri-apps/api/core';
import { Download, RefreshCw, RotateCcw, AlertCircle, CheckCircle2 } from 'lucide-react';
import { updateService, type UpdateStatus } from '../services/updateService';

export function UpdateChip(): React.JSX.Element | null {
  const [status, setStatus] = useState<UpdateStatus>(updateService.getStatus());

  useEffect(() => updateService.subscribe(setStatus), []);

  if (!isTauri()) return null;

  const { state, availableVersion, downloadedBytes, totalBytes, error } = status;
  const percent = totalBytes && downloadedBytes ? Math.round((downloadedBytes / totalBytes) * 100) : null;

  return (
    <div className="fixed bottom-4 right-4 z-[80] max-w-xs">
      <div className="rounded-2xl border border-white/10 bg-gray-950/92 backdrop-blur px-3 py-3 shadow-2xl shadow-black/30 text-white">
        {state === 'available' ? (
          <button
            onClick={() => void updateService.downloadAndInstall()}
            className="flex items-center gap-2 text-sm font-semibold text-emerald-300 hover:text-emerald-200"
          >
            <Download size={15} /> Actualizar a {availableVersion}
          </button>
        ) : state === 'downloading' ? (
          <div className="space-y-2 min-w-52">
            <div className="flex items-center justify-between gap-3 text-sm">
              <span className="flex items-center gap-2 text-blue-200"><RefreshCw size={14} className="animate-spin" /> Descargando update</span>
              {percent !== null && <span className="text-xs text-white/55">{percent}%</span>}
            </div>
            <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
              <div className="h-full rounded-full bg-blue-400 transition-all" style={{ width: percent !== null ? `${percent}%` : '35%' }} />
            </div>
          </div>
        ) : state === 'ready' ? (
          <button
            onClick={() => void updateService.relaunch()}
            className="flex items-center gap-2 text-sm font-semibold text-indigo-200 hover:text-white"
          >
            <RotateCcw size={15} /> Reiniciar para aplicar update
          </button>
        ) : state === 'error' ? (
          <div className="space-y-2 min-w-52">
            <div className="flex items-start gap-2 text-xs text-rose-200">
              <AlertCircle size={14} className="mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
            <button
              onClick={() => void updateService.checkForUpdates()}
              className="text-xs font-semibold text-white/80 hover:text-white"
            >
              Reintentar
            </button>
          </div>
        ) : state === 'up-to-date' ? (
          <div className="flex items-center gap-2 text-xs text-emerald-200">
            <CheckCircle2 size={14} /> BarberPro al dia
          </div>
        ) : (
          <button
            onClick={() => void updateService.checkForUpdates()}
            className="flex items-center gap-2 text-xs font-semibold text-white/75 hover:text-white"
          >
            <RefreshCw size={14} className={state === 'checking' ? 'animate-spin' : ''} />
            {state === 'checking' ? 'Buscando actualizacion...' : 'Comprobar updates'}
          </button>
        )}
      </div>
    </div>
  );
}
